<template>
  <div>
    <div class="text-container">
      <logo-and-nav :nav-list="nav" />
      <img class="news-banner" src="/imgs/news-banner.jpg" />
      <div class="content-container">
        <news-nav class="nav" :is-list="false"/>
        <Content class="content" />
      </div>
    </div>

    <div class="bottom-wrapper">
      <global-bottom />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import LogoAndNav from '@/components/LogoAndNav'
import NewsNav from '@/components/NewsNav'
import Content from '../components/Content'
import GlobalBottom from '@/components/GlobalBottom'
import { orgId, requestUrl } from '../common/constant'

export default {
  name: 'NewsContent',
  components: {
    LogoAndNav,
    NewsNav,
    Content,
    GlobalBottom
  },
  data () {
    return {
      nav: []
    }
  },
  async created () {
    await this.getTopNav()
  },
  methods: {
    async getTopNav () {
      // 获取顶部导航
      const nav = await axios.get(`${requestUrl}/nav/${orgId}`)
      nav.data.forEach(item => {
        if (item.title === '网上办公') {
        } else this.nav.push(item)
      })
    }
  }
}
</script>

<style scoped>
  .text-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .news-banner {
    width: 100%;
    height: 180px;
  }

  .content-container {
    display: flex;
    justify-content: space-between;
    width: 1190px;
    margin-top: 10px;
  }

  .bottom-wrapper {
    margin-top: 50px;
  }

  .latest {
    border-top: 2px solid #cccccc;
  }
</style>
